import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import DescriptionLink from 'scenes/Cms/components/DescriptionLink'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import AddContentButton from './AddContentButton'
import ConfigurationInfo from './ConfigurationInfo'
import Description from './Description'
import { getImageUrl } from './helper'

type Props = {
  data: ContentBlockData
  onEdit: () => void
}

const t = buildTranslate(
  'cms.content.app_home_page.content.block_item.featured_content'
)

const FeaturedContentDescription = ({ data, onEdit }: Props) => {
  const [css] = useStyletron()

  if (data.type !== 'featured_content') return null
  const url = data.url

  const { image } = data
  if (!image?.url && !image?.id) {
    return (
      <>
        <Description type={data.type} />
        <AddContentButton onClick={onEdit} />
      </>
    )
  }

  const imageSrc = getImageUrl(image)
  return (
    <div>
      {imageSrc && (
        <img
          src={imageSrc}
          className={`mb-s ${css({ height: '115px' })}`}
          alt={t('title')}
        />
      )}
      <DescriptionLink url={url} />
      <ConfigurationInfo contentBlock={data} />
    </div>
  )
}

export default FeaturedContentDescription
